<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6" >
            <a-form-model-item label="订单编号" prop="orderNo">
              <a-input v-model="formInline.orderNo" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7" >
            <a-form-model-item label="用户id" prop="uids">
              <a-input
                v-model="formInline.uids"
                type="user"
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7" >
            <a-form-model-item label="所属门店" prop="store">
              <a-select v-model="formInline.shopId" placeholder="请选择" style="width: 150px" @change="storeType">
                <a-select-option v-for="(item, index) in xiala" :key="index" :value="item.objId">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">

        <seckillOrderContent :formInline="formInline" ref="iason"></seckillOrderContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>

</template>

<script>
import seckillOrderContent from './seckillOrderContent.vue'
import { mallList } from "@/api/homeApi.js";
export default {
  components: {
    seckillOrderContent
  },
  data() {
    return {
      formInline: {
        userUid: "",
        orderNo: "",
        shopId:"",
        endTime: "",
        beginTime: "",
        limit: 10,
        page: 1
      },
      xiala:[]
    };
  },
  created() {
    this.getStoreListEditXiala();
  },
  methods: {
    getStoreListEditXiala() {
      mallList().then((res) => {
        this.xiala = res.data;
      });
    },
    storeType(e) {
      this.formInline.store = e
      console.log('oooooooooooooooooop', e)
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.iason.query();
    },
    handleSubmit(e) {
      console.log(this.formInline);
    },
    resetForm() {
     this.$refs.iason.getData();
    },
    handleChange(){},
    onChange(date, dateString) {
      console.log(dateString)
      this.formInline.endTime = dateString[1]
      this.formInline.beginTime = dateString[0]
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/seckillOrder/seckillOrderHome.vue